export default __webpack_public_path__ + "static/experienceImg-6c93fc6ae3f6358ab7d5bbafd2e34bc1.webp";